// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__3TeQT","description":"PatientConsentPreview_description__3sfRk"};